/**
 * playingCards — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {PORTRAIT, tagline, chips, type ToilePack} from './data'

export const playingCardsPack: ToilePack = {
    slug: 'playing-cards',
    category: 'playingcards',
    name: 'Playing cards',
    tagline: tagline('cards', 'faces', 'styles'),
    chips: chips('faces', 'styles'),
    ratio: PORTRAIT,
    readings: [
        {key: 'queen', label: 'Queen of Hearts', subject: 'a crowned queen holding a rose, a mirrored two-way court figure'},
        {key: 'ace', label: 'Ace of Spades', subject: 'one large ornate spade pip centered on the face'},
        {key: 'joker', label: 'Joker', subject: 'a capering jester in a belled cap, juggling three balls'},
    ],
    styles: [
        {key: 'engraved', label: 'Engraved', style: 'classic engraved linework, fine cross-hatching', palette: 'traditional red, black, yellow and blue', framing: 'poker-size card, rounded corners, white border'},
        {key: 'minimal', label: 'Minimal', style: 'flat geometric shapes, clean sans-serif indices', palette: 'black and one warm red on white', framing: 'poker-size card, rounded corners, white border'},
        {key: 'deco', label: 'Art-deco', style: 'symmetrical stepped ornament, fan and sunburst motifs', palette: 'gold on deep navy and cream', framing: 'poker-size card, rounded corners, white border'},
    ],
    directions: ['the King of Clubs instead', 'in green and gold', 'a busier ornamental border'],
}
